import { put } from 'redux-saga/effects'

import { clearEntity } from '../../../reducers/entities'

export default function* clearRows() {
  yield put(clearEntity({ entity: 'alerts' }))
  yield put(clearEntity({ entity: 'contractCounters' }))
  yield put(clearEntity({ entity: 'rows' }))
}
